import AutoLoadingButton from "@/components/AutoLoadingButton";
import { deleteEwaybillAccount, EwaybillAccount } from "@/services/api/ewaybillAccount";
import { Modal } from "antd";
import React from "react";

interface DeleteEwaybillAccountButtonProps {
  ewaybillAccount: EwaybillAccount;
  onRefresh: () => void;
}

const DeleteEwaybillAccountButton: React.FC<DeleteEwaybillAccountButtonProps> = ({ ewaybillAccount, onRefresh }) => {
  const handleDelete = async () => {
    const confirmed = await new Promise<boolean>((resolve) => {
      Modal.confirm({
        title: "删除共享面单后，共享给别人的面单都会暂停使用，不再支持使用",
        okText: "继续",
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

    if (!confirmed) return;

    await deleteEwaybillAccount(ewaybillAccount.id);
    Modal.success({
      title: "电子面单账号已删除",
      content: "如需恢复，重新授权该账号即可",
    });
    onRefresh();
  };

  return (
    <AutoLoadingButton className="ml5" size="small" onClick={handleDelete}>
      删除账号
    </AutoLoadingButton>
  );
};

export default React.memo(DeleteEwaybillAccountButton);
